module.exports = __webpack_public_path__ + "img/ISO_system_icon@2x.1328f5a0.png";